<template>
  <span
    oncontextmenu="return(false)"
    @dblclick="$emit('dblclick')"
    :class="['box-image']"
    :style="styles"
  >
    <transition name="fade" v-if="placeholder">
      <img
        v-show="loadedPlaceholder"
        v-on:load="onLoadedPlaceholder"
        :src="placeholder"
        :style="styles"
        class="blured placeholder"
        :class="{ loaded: loaded }"
      />
    </transition>
    <transition name="fade">
      <img
        v-on:load="onLoaded"
        :class="{ blured: !loaded }"
        :src="src"
        :style="styles"
      />
    </transition>
  </span>
</template>

<script>
export default {
  name: "image-loader",
  props: {
    src: {
      type: String,
      required: true,
    },
    placeholder: {
      type: String,
      required: false,
    },
    width: {
      type: String,
      required: false,
    },

    height: {
      type: String,
      required: false,
    },
  },

  data() {
    return {
      loaded: false,
      loadedPlaceholder: false,
    };
  },

  computed: {
    styles: function () {
      let styles = {};

      if (this.width) {
        styles.width = this.width;
      }

      if (this.height) {
        styles.height = this.height;
      }

      return styles;
    },
  },

  methods: {
    onLoaded() {
      this.loaded = true;
      this.$emit("loaded");
    },
    onLoadedPlaceholder() {
      this.loadedPlaceholder = true;
    },
  },
  watch: {
    src() {
      this.loaded = false;
      // this.loadedPlaceholder = false;
    },
    // placeholder() {
    //   this.loadedPlaceholder = false;
    // },
  },
};
</script>

<style scoped lang="css">
.fade-enter-active {
  transition: opacity 300ms ease-in-out;
  -ms-transform: opacity 300ms ease-in-out;
  -webkit-transform: opacity 300ms ease-in-out;
}

.fade-enter-to {
  opacity: 1;
}

.fade-enter {
  opacity: 0;
}

.box-image {
  display: inline-block;
  position: relative;
  overflow: hidden;
  border-radius: 4px;
  -webkit-animation-duration: 1s;
  -webkit-animation-fill-mode: forwards;
  -webkit-animation-iteration-count: infinite;
  -webkit-animation-name: placeholderSkeleton;
  -webkit-animation-timing-function: linear;
  background: #f6f7f8;
  background-image: -webkit-gradient(
    linear,
    left center,
    right center,
    from(#f6f7f8),
    color-stop(0.2, #edeef1),
    color-stop(0.4, #f6f7f8),
    to(#f6f7f8)
  );
  background-image: -webkit-linear-gradient(
    left,
    #f6f7f8 0%,
    #edeef1 20%,
    #f6f7f8 40%,
    #f6f7f8 100%
  );
  background-repeat: no-repeat;
  position: relative;
}

.box-image img {
  /* position: absolute; */
  top: 0;
  left: 0;
  /* transform: scale(1.1); */
  width: 100%;
  height: 100%;
  transition: 800ms all ease-in-out;
}

.placeholder {
  position: absolute;
  top: 0;
  left: 0;
  transform: scale(1.1);
  transition: 800ms all ease-in-out;
}

.box-image img.loaded {
  opacity: 0;
}

@-webkit-keyframes placeholderSkeleton {
  0% {
    background-position: -468px 0;
  }
  100% {
    background-position: 468px 0;
  }
}

.blured {
  filter: blur(20px);
  -webkit-filter: blur(20px);
  -moz-filter: blur(20px);
  -o-filter: blur(20px);
  -ms-filter: blur(20px);
}
</style>
